<template>
  <div class="foot">
    <div class="address">
      <h6>
        <!-- 进口商信息 -->
        <span>{{ $t("message.importer") }}</span>
        <el-button type="warning" size="mini" @click="historicalAddresses('历史进口商', 1)">
          历史进口商
        </el-button>
        <el-select v-model="importerChiose" @change="getChioseAddress('importer')" placeholder="">
          <el-option v-for="item in addressList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </h6>
      <div class="formCon">
        <el-form ref="importerForm" :model="importer" label-position="left" label-width="150px" :rules="importerRules">

          <!-- 会社： -->
          <el-form-item label="会社：">
            <el-input v-model="importer.company"></el-input>
          </el-form-item>
          <el-form-item label="会社名（ローマ字）：" prop="company_roma">
            <el-input v-model="importer.company_roma"></el-input>
          </el-form-item>
          <!-- 郵便： -->
          <el-form-item label="郵便：" prop="zip">
            <el-input v-model="importer.zip"></el-input>
          </el-form-item>
          <!-- 住所： -->
          <el-form-item label="住所：" prop="address">
            <el-input v-model="importer.address"></el-input>
          </el-form-item>
          <!-- ローマ字： -->
          <el-form-item label="ローマ字：">
            <el-input v-model="importer.address_rome"></el-input>
          </el-form-item>
          <!-- 氏名： -->
          <el-form-item label="氏名：" prop="name">
            <el-input v-model="importer.name"></el-input>
          </el-form-item>
          <!-- ローマ字： -->
          <el-form-item label="ローマ字：">
            <el-input v-model="importer.name_rome"></el-input>
          </el-form-item>
          <!-- 携帯番号： -->
          <el-form-item label="携帯番号：" prop="mobile">
            <el-input v-model="importer.mobile"></el-input>
          </el-form-item>
          <!-- 固定電話： -->
          <el-form-item label="固定電話：">
            <el-input v-model="importer.tel"></el-input>
          </el-form-item>
          <!-- 法人番号： -->
          <el-form-item label="法人番号：">
            <el-input v-model="importer.corporate_name"></el-input>
          </el-form-item>
          <!-- リアルタイム口座 -->
          <el-form-item label="リアルタイム口座：">
            <el-input v-model="importer.account"></el-input>
          </el-form-item>
          <!-- 標準コード： -->
          <el-form-item label="標準コード：">
            <el-input v-model="importer.standard_code"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="address">
      <h6>
        <!-- 收件人信息 -->
        <span>{{ $t("message.receive") }}</span>

        <!-- 从仓库选择地址 -->
        <el-button type="primary" size="mini" class="fr" @click="$refs.thirdParty.dialogVisible = true"
          style="margin-right: 10px;">从仓库选择地址</el-button>
        <el-button type="warning" size="mini" class="fr" @click="historicalAddresses('历史收件人', 2)"
          style="margin-right: 10px;">历史收件人</el-button>
        <el-select v-model="receiverChiose" @change="getChioseAddress('receiver')" placeholder="">
          <el-option v-for="item in addressList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </h6>
      <div class="formCon">
        <el-form ref="receiverForm" :model="receiver" label-position="left" label-width="150px" :rules="receiverRules">
          <!-- 会社： -->
          <el-form-item label="会社：">
            <el-input v-model="receiver.company"></el-input>
          </el-form-item>
          <el-form-item label="会社名（ローマ字）：" prop="company_roma">
            <el-input v-model="receiver.company_roma"></el-input>
          </el-form-item>
          <!-- 郵便： -->
          <el-form-item label="郵便：" prop="zip">
            <el-input v-model="receiver.zip"></el-input>
          </el-form-item>
          <!-- 住所： -->
          <el-form-item label="住所：" prop="address">
            <el-input v-model="receiver.address"></el-input>
          </el-form-item>
          <!-- ローマ字： -->
          <el-form-item label="ローマ字：">
            <el-input v-model="receiver.address_rome"></el-input>
          </el-form-item>
          <!-- 氏名： -->
          <el-form-item label="氏名：" prop="name">
            <el-input v-model="receiver.name"></el-input>
          </el-form-item>
          <!-- ローマ字： -->
          <el-form-item label="ローマ字：">
            <el-input v-model="receiver.name_rome"></el-input>
          </el-form-item>
          <!-- 携帯番号： -->
          <el-form-item label="携帯番号：" prop="mobile">
            <el-input v-model="receiver.mobile"></el-input>
          </el-form-item>
          <!-- 固定電話： -->
          <el-form-item label="固定電話：">
            <el-input v-model="receiver.tel"></el-input>
          </el-form-item>
          <!-- 法人番号： -->
          <el-form-item label="法人番号：">
            <el-input v-model="receiver.corporate_name"></el-input>
          </el-form-item>
          <!-- リアルタイム口座 -->
          <el-form-item label="リアルタイム口座：">
            <el-input v-model="receiver.account"></el-input>
          </el-form-item>
          <!-- 標準コード： -->
          <el-form-item label="標準コード：">
            <el-input v-model="receiver.standard_code"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="otherBox">
      <div class="chooseALogisticsMethod">
        <h5>
          国際運送会社選択：
        </h5>

        <el-select v-model="logistics_id" @change="getlogisticsChiose" placeholder="" class="selectLogistics">
          <el-option v-for="item in logisticsList" :key="item.id"
            :label="item.name == 'RW船便' ? item.name + '--(仅VIP可使用)' : item.name" :value="item.id"
            :disabled="item.name == 'RW船便' && is_vip != 1">
          </el-option>
        </el-select>
        <!-- <span class="vip" v-if="logistics_id == 20">
          仅VIP可使用
        </span> -->

        <!-- 屏蔽邮件 -->
        <el-checkbox v-model="block_email" style="margin-left: 50px;">{{ $t('message.blockMail') }}</el-checkbox>
        <p class="chooseALogisticsMethodPrompt">
          {{
            logistics.tips
          }}
        </p>
        <h5>
          特殊要求备注：
        </h5>
        <el-input class="textBox" type="textarea" :rows="7" placeholder="请输入内容" v-model="client_remark">
        </el-input>
        <h5>
          附件上传：
        </h5>
        <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :on-success="handleAvatarSuccess"
          :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3"
          :on-exceed="handleExceed" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="chooseALogisticsMethodPrompt">单个文件不能超过50MB，一个订单最多上传3个文件</div>
        </el-upload>
      </div>
    </div>
    <!-- 第三方仓库地址 -->
    <thirdParty ref="thirdParty" />
    <!-- 历史地址 -->
    <historicalAddresses ref="historicalAddresses" @use-address="useHistoricalAddress" />
  </div>
</template>
<script>
import thirdParty from '@/components/common/thirdParty'
import historicalAddresses from './historicalAddresses'
export default {
  data() {
    return {
      importer: {}, //表单的数值
      importerRules: {
        company_roma: [
          { validator: (rule, value, callback) => this.validateCompanyRoma(this.importer, value, callback), trigger: 'blur' },
        ],

        zip: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],
        address: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

        name: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

        mobile: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

      }, //选择地址表单的规则
      importerChiose: "", //选择地址下拉框的值
      receiver: {
        zip_code: '',
        contacts: '',
        address: '',
        standard_no: '',
        address_roma: '',
        contacts_roma: '',
        standard_no: '',
        bank_no: '',
        tax_no: '',
        account: '',
        address_rome: '',
        company: '',
        company_roma: '',
        corporate_name: '',
        mobile: '',
        name: '',
        name_rome: '',
        standard_code: '',
        standard_no: '',
        tel: '',
        title: '',
        zip: '',
      }, //选中的收件人地址
      receiverRules: {
        company_roma: [
          { validator: (rule, value, callback) => this.validateCompanyRoma(this.receiver, value, callback), trigger: 'blur' },
        ],

        zip: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],
        address: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

        name: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

        mobile: [
          // 请输入这个参数
          { required: true, message: this.$t('message.pleaseEnterThisParameter'), trigger: 'blur' },
        ],

      }, //收件人地址表单规则
      receiverChiose: "", //选中的收件人地址id
      addressList: [], //用户地址列表
      logisticsList: [], //所有物流方式列表
      logistics_id: '', //选中的物流方式id
      logistics: {}, //选中的物流方式
      fileList: [], //用户上传附件
      client_remark: '', // 用户整个配送单的备注
      block_email: false, // 是否屏蔽邮件
      user_id: this.$route.query.userID ? this.$route.query.userID : this.$route.query.porder_sn.split('-')[1],
      is_vip: 0,
      ueserDetail: {},// 客户信息
    };
  },
  components: {
    thirdParty,
    historicalAddresses
  },
  computed: {},
  created() {
    this.userAddressList();
    this.internationalLogisticsList()

  },
  methods: {
    // 第三方地址选择成功
    addAddressSuccess(item) {
      this.receiver.zip_code = item.zip.replaceAll('〒', '')
      this.receiver.contacts = item.name
      this.receiver.address = item.address_jpn
      this.receiver.standard_no = ''
      this.receiver.address_roma = ''
      this.receiver.contacts_roma = ''
      this.receiver.standard_no = ''
      this.receiver.bank_no = ''
      this.receiver.tax_no = ''
      this.receiver.account = ''
      this.receiver.address_rome = ''
      this.receiver.company = ''
      this.receiver.company_roma = ''
      this.receiver.corporate_name = ''
      this.receiver.mobile = item.mobile
      this.receiver.name = item.name
      this.receiver.name_rome = ''
      this.receiver.standard_code = ''
      this.receiver.standard_no = ''
      this.receiver.tel = ''
      this.receiver.title = ''
      this.receiver.zip = item.zip.replaceAll('〒', '')
      this.$forceUpdate()
    },
    clientDetail() {
      this.$api.clienteleApi
        .clientDetail({ user_id: this.user_id })
        .then((res) => {
          let detail = res.data;
          this.ueserDetail = res.data
          this.is_vip = res.data.is_pay_vip_now

          if (this.importer.corporate_name == '' && this.importer.account == '' && this.importer.standard_code == '') {
            this.importer.corporate_name = detail.bank_no
            this.importer.account = detail.bank_no
            this.importer.standard_code = detail.tax_no


          }
        });
    },
    // 验证两个表单并返回结果
    registerCheck() {
      let flog = true
      this.$refs['importerForm'].validate((valid) => {
        if (valid) {
          console.log(1);

        } else {
          flog = false
        }
      });
      this.$refs['receiverForm'].validate((valid) => {
        if (valid) {
          console.log(2);
        } else {
          flog = false
        }
      });
      return flog
    },
    validateCompanyRoma(data, value, callback) {
      if (data.company && data.corporate_name && !value) {
        callback(new Error('填写会社和法人番号时，会社名（ローマ字）必填'))
        return
      }
      callback()
    },
    // 上传组件删除
    handleRemove(file, fileList) {
      // 这里删除事件调用之后不知道为什么会多处老几个参数,不直接用fileList赋值也会多出来
      // this.fileList = fileList
      this.fileList.splice(fileList.findIndex((item) => {
        return item.file == file.url
      }), 1)
    },
    // 上传成功事件
    handleAvatarSuccess(response, file, fileList) {
      if (fileList.every(it => it.status == 'success')) {//必须判断fileList是否全部加载完成，因为多选上传的时候有多个请求，但是第一个问价上传成功的时候就会调用上传成功事件并且上传成功事件只会调用一次，如果不加会只添加第一个文件到数组里，后面的文件会接口里上传成功但是添加不到数组里。
        fileList.forEach((item) => {
          if (item.response && item.response.code === 0) {
            this.fileList.push({ name: item.name, file: item.response.data })
          }
        })
      }
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 根据选中的id匹配物流方式
    getlogisticsChiose() {
      this.logistics = this.logisticsList.find((item) => {
        return item.id == this.logistics_id
      })
    },
    // 根据选中的地址id匹配地址
    getChioseAddress(formName) {
      // 根据选中的地址id匹配地址
      this[formName] = JSON.parse(
        JSON.stringify(
          this.addressList.find((item) => {
            return item.id == this[formName + "Chiose"];
          })
        )
      );

      if (this[formName].corporate_name == null && this[formName].account == null && this[formName].standard_code == null) {
        this[formName].corporate_name = this.ueserDetail.bank_no
        this[formName].account = this.ueserDetail.bank_no
        this[formName].standard_code = this.ueserDetail.tax_no
      }
      this[formName].company_roma = this[formName].company_roma || ''

    },
    // 打开历史地址弹窗
    historicalAddresses(title, type) {
      this.$refs.historicalAddresses.title = title
      this.$refs.historicalAddresses.datas = {
        type: type,
        porder_sn: this.$route.query.porder_sn || '',
        match_porder_sn: '',
        keyword: '',
        user_id: this.user_id
      }
      this.$refs.historicalAddresses.dialogVisible = true
      this.$refs.historicalAddresses.historyDeliveryAddressList()
    },
    // 使用历史地址回填进口商或收件人信息
    useHistoricalAddress(item, type) {
      const formName = type == 1 ? 'importer' : 'receiver'
      this[formName] = this.formatHistoryAddress(item)
      this[formName + 'Chiose'] = ''
      this.$nextTick(() => {
        if (this.$refs[formName + 'Form']) {
          this.$refs[formName + 'Form'].clearValidate()
        }
      })
    },
    // 将历史地址字段转换成当前提交表单使用的字段
    formatHistoryAddress(item) {
      const address = Object.assign({}, item, {
        zip_code: item.zip_code || item.zip || '',
        contacts: item.contacts || item.name || '',
        standard_no: item.standard_no || item.standard_code || '',
        address_roma: item.address_roma || item.address_rome || '',
        contacts_roma: item.contacts_roma || item.name_rome || '',
        bank_no: item.bank_no || item.account || '',
        tax_no: item.tax_no || item.corporate_name || '',
        address_rome: item.address_rome || item.address_roma || '',
        company_roma: item.company_roma || '',
        corporate_name: item.corporate_name || item.tax_no || '',
        account: item.account || item.bank_no || '',
        name: item.name || item.contacts || '',
        name_rome: item.name_rome || item.contacts_roma || '',
        standard_code: item.standard_code || item.standard_no || '',
        zip: item.zip || item.zip_code || '',
      })
      if (!address.corporate_name && !address.account && !address.standard_code) {
        address.corporate_name = this.ueserDetail.bank_no
        address.account = this.ueserDetail.bank_no
        address.standard_code = this.ueserDetail.tax_no
      }
      return address
    },
    //  2023/2/20 获取用户地址列表,提出配送单时两种地址使用同一套地址列表,所以后端返回一个数组
    userAddressList() {
      this.$api.clienteleApi
        .userAddressList({
          user_id: this.user_id
        })
        .then((res) => {
          this.addressList = res.data;
          // 寻找默认地址并赋值,default_importer=1为默认进口商,default_receiver=1为默认收件地址
          res.data.forEach((element) => {
            if (element.default_importer == 1) {
              this.importerChiose = element.id;
              this.getChioseAddress("importer");
            }
            if (element.default_receiver == 1) {
              this.receiverChiose = element.id;
              this.getChioseAddress("receiver");
            }
          });
          this.clientDetail()
        });
    },
    // 获取物流方式列表
    internationalLogisticsList() {
      this.$api.siteConfiguration
        .internationalLogisticsList({ is_show: 1 })
        .then((res) => {
          this.logisticsList = res.data;
        });
    }
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

* {
  box-sizing: border-box;
}

.foot {
  display: flex;
  margin-top: 40px;

  .address {
    flex: 0 0 488px;
    margin-right: 24px;
    padding: 24px;
    border-radius: 8px;
    background: #f0f9eb;
    border: 1px solid #edeff4;

    h6 {
      border-bottom: 1px solid #edeff4;
      padding-bottom: 20px;
      margin-bottom: 16px;
      font-size: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .otherBox {
    flex: 1;
    background-color: #EDEFF4;
    padding: 24px;

    h5 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .selectLogistics {
      margin-bottom: 10px;
    }

    .textBox {
      margin-bottom: 40px;
    }

    .chooseALogisticsMethodPrompt {
      color: red;
      width: 217px;
      margin-top: 10px;
      margin-bottom: 20px;
      min-height: 20px;
    }
  }
}

.vip {
  color: red;
}
</style>
